import type { CSSProperties, ReactNode } from 'react'

export type ScorePadProps = {
  children: ReactNode
  style?: CSSProperties
}

export const ScorePad = ({ children, style }: ScorePadProps) => (
  <div
    style={{
      background: 'var(--paper)',
      border: '1px solid var(--line-soft)',
      borderRadius: 6,
      overflow: 'hidden',
      ...style,
    }}
  >
    {children}
  </div>
)

export type ScorePadRowProps = {
  children: ReactNode
  onClick?: () => void
  style?: CSSProperties
}

export const ScorePadRow = ({ children, onClick, style }: ScorePadRowProps) => (
  <div
    onClick={onClick}
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: 10,
      padding: '10px 14px',
      borderBottom: '1.5px dashed var(--paper-edge)',
      cursor: onClick ? 'pointer' : undefined,
      ...style,
    }}
  >
    {children}
  </div>
)
